<template>
	<AppHeader
		:logo="logo"
		:headerButton1="headerButton1"
		:headerButton2="headerButton2"
	/>

	<div class="flex-grow-1">
		<UiElement class="d-flex flex-column h-100 py-0" :settings="appearance.body.settings">
			<div class="flex-grow-1" v-if="menu && menu.length">
				<template v-if="page.options.view.value === 'grid'">
					<div
						style="width: clamp(910px, 100vw, 1080px);"
						:style="{ 'margin-left': `-${appearance.body.settings.spacing.padding[3]}px`}"
					>
						<Swiper
							ref="swiperRef"
							:slides-per-view="3.5"
							:space-between="40"
							:centered-slides="true"
							:loop="false"
							:initial-slide="initialSlideIndex"
							:slide-to-clicked-slide="true"
							class="category-carousel"
							@swiper="onSwiper"
							@slideChange="onSlideChange"
						>
							<SwiperSlide v-for="(categories, index) in menu ?? []" :key="`category-${index}`" class="slide">
								<UiElement
									class="position-relative"
									style="height: 280px; width: 280px; overflow: hidden;"
									:settings="block1"
								>
									<img
										v-show="!!categories?.image && categories?.image !== 'null'"
										:src="categories?.image"
										style="object-fit: cover"
										alt="img"
										class="w-100 h-100"
										:class="{ 'd-block': !!categories?.image && categories?.image !== 'null' }"
									/>

									<img
										v-show="!categories?.image || categories?.image === 'null'"
										class="w-100"
										:class="{ 'd-block': !categories?.image || categories?.image === 'null' }"
										src="https://www.bifolcomatty.co.uk/wp-content/uploads/2019/08/placeholder-square.jpg"
										alt
									/>

									<UiElement
										class="position-absolute bottom-0 start-0 d-flex align-items-end w-100"
										:settings="card1"
									>
										<UiText
											:settings="heading1" :content="categories.names[locale]
												|| (locale === 'cs' && categories.names.cz)
												|| categories.names.en
												|| categories.name"
										>
										</UiText>
									</UiElement>
								</UiElement>
							</SwiperSlide>
						</Swiper>
					</div>

					<div class="flex-grow-1">
						<div
							v-for="(categoryProducts, categoryProductsIndex) in productsArray"
							:key="`category-products-index-${categoryProductsIndex}`"
							class="flex-row flex-wrap align-content-start gap-4 mt-5 flex-grow-1"
							:class="{
								'd-flex': +categoryProductsIndex === +currentMenuIndex,
								'd-none': +categoryProductsIndex !== +currentMenuIndex
							}"
						>
							<div
								v-for="(product, index) in categoryProducts"
								:key="`product-${index}`"
								class="products"
								style="width: calc(100% / 3 - 1rem)"
							>
								<UiElement class="position-relative" :settings="block2" style="overflow: hidden;">
									<div style="aspect-ratio: 1">
										<img
											class="w-100 h-100"
											:class="!!product?.image && product?.image !== 'null' ? 'd-block' : 'd-none'"
											style="object-fit: cover"
											:src="product.image"
											alt=""
										/>

										<img
											class="w-100 h-100"
											:class="!product?.image || product?.image === 'null' ? 'd-block' : 'd-none'"
											style="object-fit: cover"
											src="https://www.bifolcomatty.co.uk/wp-content/uploads/2019/08/placeholder-square.jpg"
											alt=""
										/>

										<div @mousedown="showProduct(product)" class="product-overlay" />
									</div>

									<UiElement
										class="position-absolute bottom-0 start-0 d-flex align-items-end w-100"
										:settings="card2"
									>
										<div class="w-100">
											<div class="d-flex align-items-end justify-content-between">
												<div>
													<UiText :settings="heading2" :content="product.label">
													</UiText>

													<UiText
														:settings="heading2"
														:content="`${smartNumberFormat(product.price)}&nbsp;${currency}`"
													/>
												</div>

												<UiButton
													v-if="hasModifiersOrIngredients(product)"
													:settings="buttonAmount6"
													style="position: relative; z-index: 2"
													@touchstart="showProduct(product)"
												>
													<svg width="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
														<rect
															x="0.233398" y="11.4"
															width="3.5625"
															height="17.2667"
															transform="rotate(-90 0.233398 11.4)"
															fill="black"
														/>
														<rect
															width="3.29596" height="11.7713"
															transform="matrix(0.700822 -0.713336 0.700822 0.713336 10.2666 3.71558)" fill="black"
														/>
														<rect
															width="3.29596" height="11.7713"
															transform="matrix(0.700822 0.713336 -0.700822 0.713336 18.5164 7.37152)" fill="black"
														/>
													</svg>
												</UiButton>

												<UiButtonAmount
													v-else
													:settings="buttonAmount6"
													:product="product"
													style="position: relative; z-index: 2"
												>
													<template #default="{ count }">
														<UiText :settings="textAmount3" style="color: #fff !important;" :content="count" />
													</template>
												</UiButtonAmount>

												<div @mousedown="showProduct(product)" class="product-overlay" />
											</div>
										</div>
									</UiElement>
								</UiElement>
							</div>
						</div>
					</div>
				</template>

				<template v-else>
					<UiText :settings="text1" class="text-center" content="1/3" />

					<UiText :settings="heading3" class="text-center" :content="translations?.shrnuti || '{listViewTitle}'" />

					<div v-for="(category, index) in categoriesArray ?? []" :key="`menu-list-${index}`">
						<UiText :settings="heading4" :content="'&nbsp;'" style="opacity: 0" />

						<hr class="border-3" style="color: #000; opacity: 1;">

						<UiText :settings="heading4" :content="category.name" />

						<hr class="border-3" style="color: #000; opacity: 1;">

						<ProductsList :products="category.products">
							<template #item="product">
								<div class="d-flex align-items-start">
									<div
										class="d-flex flex-row justify-content-between align-items-start flex-grow-1 pe-4 mt-2"
										@touchstart="showProduct(product)"
									>
										<UiText :settings="heading4" :content="product.label" />

										<UiText
											:settings="heading4" class="ps-3"
											:content="`${ smartNumberFormat(product.price, 0) }&nbsp;${currency}`"
										/>
									</div>

									<div v-if="hasModifiersOrIngredients(product)" class="d-flex align-items-center">
										<UiButton :settings="buttonAmount3" style="opacity: 0" />

										<UiText
											:settings="textAmount2"
											style="opacity: 0"
											content="0"
										/>

										<UiButton
											:settings="buttonAmount3"
											style="position: relative; z-index: 2"
											@touchstart="showProduct(product)"
										>
											<svg width="29" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
												<rect
													x="0.233398" y="11.4" width="3.5625" height="17.2667" transform="rotate(-90 0.233398 11.4)"
													fill="white"
												/>
												<rect
													width="3.29596" height="11.7713"
													transform="matrix(0.700822 -0.713336 0.700822 0.713336 10.2666 3.71558)" fill="white"
												/>
												<rect
													width="3.29596" height="11.7713"
													transform="matrix(0.700822 0.713336 -0.700822 0.713336 18.5164 7.37152)" fill="white"
												/>
											</svg>
										</UiButton>
									</div>

									<UiButtonAmount v-else :product="product" :settings="buttonAmount3">
										<template #default="{ count }">
											<UiText
												:settings="textAmount2"
												:content="count"
												:style="count === 0 ? 'opacity: .2' : ''"
											/>
										</template>
									</UiButtonAmount>
								</div>

								<hr class="border-3" style="color: #000; opacity: 1;">
							</template>
						</ProductsList>
					</div>
				</template>
			</div>

			<div class="flex-grow-1" v-else>
				You have to add menu to kiosk with id {{ kioskId }} first
			</div>

			<UiElement
				class="position-sticky bottom-0 start-0 w-100 px-0"
				:settings="appearance.body.settings"
				style="z-index: 2"
			>
				<div class="d-flex justify-content-end gap-4">
					<UiButtonArrow
						:settings="button1"
						:body="appearance.body.settings"
						right
						class="w-50"
						@touchstart="goSummary"
						:content="`${ translations?.totalsummary || '{totalsummary}' } ${ formatNumberWithSpaces(smartNumberFormat(total)) }&nbsp;${currency}`"
					>
					</UiButtonArrow>
				</div>
			</UiElement>

			<UiText
				v-if="page.options.view.value !== 'grid'"
				:settings="text1"
				class="text-center"
				:content="translations?.disclaimer || '{disclaimer}'"
			/>
		</UiElement>
	</div>

	<DialogEmptyOrder :show="isDialogEmptyOrder" @submit="isDialogEmptyOrder = false" />
</template>

<script setup>
	import 'swiper/swiper-bundle.css';
	import { computed, onMounted, ref } from 'vue';
	import { storeToRefs } from 'pinia';
	import { useRouter } from 'vue-router';
	import { useRoute } from 'vue-router';

	import { useInheritedSettings } from '@/composables/useInheritedSettings';
	import { useKioskRoute } from '@/composables/useKioskRoute';

	import { useThemeStore } from '@/stores/useThemeStore';
	import { useCatalogStore } from '@/stores/useCatalogStore';
	import { useOrderStore } from '@/stores/useOrderStore';
	import { useKioskStore } from '@/stores/useKioskStore';
	import { useTranslationsStore } from '@/stores/useTranslationsStore';

	import { Swiper, SwiperSlide } from 'swiper/vue';

	import AppHeader from '@/components/AppHeader.vue';
	import ProductsList from '@/components/ProductsList.vue';
	import UiElement from '@/components/UI/UiElement.vue';
	import UiButton from '@/components/UI/UiButton.vue';
	import UiButtonAmount from '@/components/UI/UiButtonAmount.vue';
	import UiButtonArrow from '@/components/UI/UiButtonArrow.vue';
	import UiText from '@/components/UI/UiText.vue';
	import DialogEmptyOrder from '@/components/Dialogs/DialogEmptyOrder.vue';
	import { useDataUtils } from '@/composables/useDataUtils';

	const router = useRouter();
	const route = useRoute();
	const { makePath } = useKioskRoute();
	const themeStore = useThemeStore();
	const catalogStore = useCatalogStore();
	const orderStore = useOrderStore();
	const translationsStore = useTranslationsStore();
	const kioskStore = useKioskStore();

	const isDialogEmptyOrder = ref(false);
	const swiperRef = ref(null);
	const currentMenuIndex = ref(0);

	const { translations } = storeToRefs(translationsStore);
	const { theme } = storeToRefs(themeStore);
	const { menu } = storeToRefs(catalogStore);
	const { total } = storeToRefs(orderStore);
	const { locale, currency } = storeToRefs(kioskStore);
	const { kioskId } = kioskStore;

	const { setProduct } = catalogStore;
	const { smartNumberFormat, formatNumberWithSpaces } = useDataUtils();

	const page = computed(() => theme.value.pages.products);
	const appearance = computed(() => page.value.appearance);
	const elements = computed(() => page.value.elements);

	const productsArray = computed(() => allProductsByCategory.value || []);

	const allProductsByCategory = computed(() => {
		if (!menu.value) return {};
		const result = {};
		menu.value.forEach((category, i) => {
			result[i] = category.products.map(product => {
				const label = product.names[locale.value]
					|| (locale.value === 'cs' && product.names.cz)
					|| product.names.en
					|| product.name;

				return {
					id: product.id,
					label,
					image: product.image,
					price: product.price,
					amount: 0,
					modifiers: [],
					product_order_index: `${ product.id }_`,
					details: product
				};
			});
		});
		return result;
	});

	const categoriesArray = computed(() => {
		return menu.value.map(item => {
			const name = item.names[locale.value]
				|| (locale.value === 'cs' && item.names.cz)
				|| item.names.en
				|| item.name
				|| '{no-category-name}'

			const products = item.products.map(product => {
				const label = product.names[locale.value]
					|| (locale.value === 'cs' && product.names.cz)
					|| product.names.en
					|| product.name;

				const productOrderIndex = `${ product.id }_`;

				return {
					id: product.id,
					label,
					image: product.image,
					price: product.price,
					amount: 0,
					modifiers: [],
					product_order_index: productOrderIndex,
					details: product
				};
			});

			return {
				name,
				products
			}
		});
	});

	const initialSlideIndex = computed(() => {
		if (!menu.value || !menu.value.length) return 0;

		const categoryId = route.query.category;

		if (categoryId) {
			return categoryId;
		}

		return menu.value.length > 1 ? 1 : 0;
	});


	const button1 = useInheritedSettings(computed(() => elements.value?.button1));
	const logo = useInheritedSettings(computed(() => elements.value?.logo));
	const headerButton1 = useInheritedSettings(computed(() => elements.value?.headerButton1));
	const headerButton2 = useInheritedSettings(computed(() => elements.value?.headerButton2));
	const block1 = useInheritedSettings(computed(() => elements.value?.block1));
	const block2 = useInheritedSettings(computed(() => elements.value?.block2));
	const card1 = useInheritedSettings(computed(() => elements.value?.card1));
	const card2 = useInheritedSettings(computed(() => elements.value?.card2));
	const heading1 = useInheritedSettings(computed(() => elements.value?.heading1));
	const heading2 = useInheritedSettings(computed(() => elements.value?.heading2));
	const heading3 = useInheritedSettings(computed(() => elements.value?.heading3));
	const heading4 = useInheritedSettings(computed(() => elements.value?.heading4));
	const buttonAmount6 = useInheritedSettings(computed(() => elements.value?.buttonAmount6));
	const textAmount3 = useInheritedSettings(computed(() => elements.value?.textAmount3));
	const buttonAmount3 = useInheritedSettings(computed(() => elements.value?.buttonAmount3));
	const textAmount2 = useInheritedSettings(computed(() => elements.value?.textAmount2));
	const text1 = useInheritedSettings(computed(() => elements.value?.text1));

	function onSwiper(s) {
		swiperRef.value = s;
	}

	function hasModifiersOrIngredients(product) {
		const hasModifiers = !!product.details?.modifier?.modifiers && product.details.modifier.modifiers.length > 0;
		const hasIngredients = !!product.details?.ingredients && product.details.ingredients.length > 0;

		return hasModifiers || hasIngredients;
	}

	function showProduct(product) {
		setProduct(product);

		router.push(makePath('/product'));
	}

	function onSlideChange(s) {
		currentMenuIndex.value = s.realIndex;

		router.replace({
			query: {
				...route.query,
				category: s.realIndex
			}
		});
	}


	function goSummary() {
		if (total.value === 0) {
			isDialogEmptyOrder.value = true;
			return;
		}

		router.push(makePath('/summary'));
	}

	function preloadImagesFromMenu(menu) {
		if (!menu || !menu.length) return;

		menu.forEach(category => {
			if (category.image) {
				const img = new Image();
				img.src = category.image;
			}

			if (Array.isArray(category.products)) {
				category.products.forEach(product => {
					if (product.image) {
						const img = new Image();
						img.src = product.image;
					}
				});
			}
		});
	}

	onMounted(() => {
		preloadImagesFromMenu(menu.value);
	})
</script>

<style scoped>
	.category-carousel {
		width: 100%;
		padding: 50px 0;
	}

	.slide {
		transition: transform 0.3s;
	}

	.swiper-slide-active {
		transform: scale(1.35);
		z-index: 10;
	}

	.product-overlay {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
	}
</style>